import axios, { AxiosPromise } from 'axios';

import { IPalletBaseType } from '../../../@types/model/masterData/palletBaseType/palletBaseType';

export default class PalletBaseTypeHttpService {
    public static getPalletBaseTypeData() : AxiosPromise<Array<IPalletBaseType>> {
        return axios.get(`${API_URL}/v1/PalletBaseType/GetAllWeb`);
    }

    public static addOrUpdatePalletBaseType(data : IPalletBaseType) : AxiosPromise<IPalletBaseType> {
        return axios.post(`${API_URL}/v1/PalletBaseType/PostPalletBaseType`, data);
    }

    public static deletePalletBaseType(palletBaseTypeId : number) : AxiosPromise<IPalletBaseType> {
        return axios.delete(`${API_URL}/v1/PalletBaseType/Delete`, {
            params : { palletBaseTypeId },
        });
    }
}
